.trigger {
	display: flex;
	align-items: center;
	width: 100%;
	height: var(--input-height);
	padding: var(--padding-base-y) var(--padding-base-x);
	font-family: inherit; /* buttons don't inherit the app font on their own */
	font-size: var(--font-size-base);
	line-height: var(--line-height-base);
	text-align: left;
	color: var(--input-color);
	border: 1px solid var(--input-border);
	border-radius: var(--input-border-radius);
	box-sizing: border-box;
	background-color: var(--input-bg);
}

.trigger[data-placeholder] {
	color: var(--input-color-placeholder);
}

.trigger[data-invalid] {
	border-color: var(--state-danger-text);
}

.trigger:focus,
.trigger[data-popup-open] {
	outline: 0;
	box-shadow: 0 0 0 3px var(--color-primary-focus-ring);
}

.trigger[data-disabled],
.trigger[data-readonly] {
	background-color: var(--input-bg-disabled);
}

.trigger[data-disabled] {
	cursor: not-allowed;
}

.value {
	display: block;
	flex: 1;
	min-width: 0; /* lets the flex item shrink below its text so ellipsis kicks in */
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.icon {
	display: flex;
	align-items: center;
	flex: none;
	margin-left: auto;
	/* The original select.form-control paints the caret SVG as a background at
	   100% 50%, scaled to the padding-box height and flush against the border —
	   inside the horizontal padding. Cancel the padding and match that height. */
	margin-right: calc(-1 * var(--padding-base-x));
	fill: var(--dropdown-trigger-color);
}

.icon svg {
	display: block;
	height: calc(var(--input-height) - 2px); /* padding-box height: trigger height minus the 1px borders */
}
